module.exports = __webpack_public_path__ + "static/media/2.7d64b469.jpg";